import { Timestamp } from "firebase/firestore";
import { useBetContext } from "../../../../../context/BetContext.tsx";
import { calcProfit, calcStake, isPrincipalBoardMarket, resolveSelectedTeams } from "../../../../../helpers/functions.tsx";
import { BetDetails } from "../../../../../models/MyBetModel.tsx";
import { Odd } from "../../../../../models/Odd_response_model.tsx";
import { Schedule } from "../../../../../models/Schedule.tsx";
import { DataGames } from "../../GamesProps/DataGames.tsx";
import { useUser } from "../../../../../context/UserContext.tsx";
import React from "react";
import { lockPageScroll } from "../../../../../helpers/scrollPageToTop.ts";
import { DEFAULT_PROPS_LOGO } from "../../../modals/BetLogo.tsx";
import { getFiguresTimeZone } from "../../../../../helpers/figuresTime.tsx";

interface ISpecialDataComponent {
    game: Schedule,
    showLimit: Record<string, number>;
    setShowLimit: React.Dispatch<React.SetStateAction<Record<string, number>>>;
    marketId: string;
    onShowBetsModal: (bets?: BetDetails[]) => void;
    isSpecial?: boolean;
    setErrorMessage: React.Dispatch<React.SetStateAction<string>>;

}
export function SpecialDataComponent(props: ISpecialDataComponent) {

    const { game, showLimit, marketId, setShowLimit, onShowBetsModal, setErrorMessage } = props;
    const { bets, upsertBet } = useBetContext();
    const { user } = useUser();
    if (!user?.userName) {
        throw new Error("User not authenticated");
    }
    const marketKeyFromLeague =
        game.leagueKey && game.sport?.name && game.league?.name
            ? (() => {
                const prefix = `${game.sport.name}-${game.league.name}-`;
                return game.leagueKey.startsWith(prefix)
                    ? game.leagueKey.slice(prefix.length)
                    : undefined;
            })()
            : undefined;
    const marketTitle = game.odds?.[0]?.market || marketKeyFromLeague;
    const playerTimeZone = getFiguresTimeZone();
    const formattedDate = new Date(game.start_date).toLocaleDateString('en-US', {
        timeZone: playerTimeZone,
        weekday: 'long',
        month: 'long',
        day: 'numeric',
    }).toUpperCase();
    const gameTimeDate = new Date(game.start_date ?? '')
    const time = gameTimeDate.toLocaleTimeString('en-US', {
        timeZone: playerTimeZone,
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
    });
    const totalBets = bets.length;

    let gameTime = Timestamp.fromDate(new Date(game.start_date));

    const _build = (reward: number, selected: Odd): BetDetails => {
        const price = selected?.price;
        let risk = 0;
        let finalReward = 0;

        if (price > 0) {
            risk = reward;
            finalReward = calcProfit(risk, price);
        } else {
            finalReward = reward;
            risk = calcStake(finalReward, price);
        }
        const { teamId, opposingTeam } = resolveSelectedTeams(
            selected,
            game.home_competitors[0],
            game.away_competitors?.[0],
        );

        const logo = DEFAULT_PROPS_LOGO;
        const marketLower = String(selected.market ?? "").toLowerCase();
        let selectionType: string | undefined;
        if (marketLower.includes("moneyline")) {
            selectionType = "ML";
        } else if (selected.selection_line) {
            const line = selected.selection_line.toLowerCase();
            if (line === "over") selectionType = "O";
            else if (line === "under") selectionType = "U";
            else selectionType = selected.selection_line;
        }

        const isPrincipal = isPrincipalBoardMarket(undefined, selected.market_id);
        const gameType = isPrincipal ? undefined : "props";

        const newBet: BetDetails = {
            fixture_id: game.id,
            id_selection: selected.id,
            bet: risk,
            reward: finalReward,
            sport: game.sport.name,
            league: game.league.name,
            gameDate: gameTime,
            gameId: game.game_id,
            marketName: selected.market,
            betName: selected.selection,
            betDate: Timestamp.now(),
            betStatus: 'pending',
            betType: 'Straight',
            odd: selected,
            teamId: teamId,
            opposingTeam: opposingTeam,
            logo: logo,
            ...(selectionType ? { selectionType } : {}),
            ...(gameType ? { gameType } : {}),
        };

        return newBet;
    };

    const onRequestBetsModal = (bet?: Partial<BetDetails>, openModal: boolean = false) => {
        if (user.status !== "Active") {
            setErrorMessage("Your account is in read-only mode."
            );
            return;
        }
        const reward = bet?.reward ?? 0;

        const odd = bet?.odd;

        if (!odd) return;
        if (!openModal && !reward) return;

        if (openModal) lockPageScroll();

                const newBet = _build(reward, odd);

        const updatedBets = (() => {
            const exists = bets.find(b => b.id_selection === newBet.id_selection);

            if (exists) {
                return bets.map(b =>
                    b.id_selection === newBet.id_selection ? newBet : b
                );
            }

            return [...bets, newBet];
        })();

        upsertBet(newBet);

        // if (bets.find(bet => bet.id_selection === odd.id)) {
        //     updateBet(
        //         _build(
        //             reward,
        //             odd,
        //         )
        //     );
        // } else {
        //     const newBet = _build(
        //         reward,
        //         odd,
        //     );
        //     addBet(newBet);
        // }


        if (openModal) {
            onShowBetsModal(updatedBets);
        }
    };


    return (
        <>
            <div >
                <div className="schedule-table">
                    <div className='container-table'>
                        <div className='d-flex justify-content-between align-items-center'>
                            {/* <div>
                                <img src={game.leagueLogo} className="league-logo" alt="" />
                            </div> */}
                            <div className="teamsMarkets-container ">
                                <span className='market-title teko'>
                                    {marketTitle
                                        ? `${game.league.name} - ${marketTitle}`
                                        : game.league.name}
                                </span>
                                <span className='teams-special teko'>
                                    {game.away_competitors[0]?.name} @ {game.home_competitors[0]?.name}
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="container-date-special">
                    <span className="date-special">{formattedDate}</span>  <span className="time-special teko">{time}</span>
                </div>
                <DataGames
                    marketData={[game]}
                    showLimit={showLimit}
                    setShowLimit={setShowLimit}
                    marketId={marketId}
                    onRequestBetsModal={onRequestBetsModal}
                    isSpecial={true}
                />
            </div>
        </>
    )
}